// extracted by mini-css-extract-plugin
export default {"leftPlan":"Pricing_leftPlan__qWQxP","rightPlan":"Pricing_rightPlan__nL2PO"};